import { IServicePeriod, IPeriodsByService, IPublication, IDiffPricing } from '../../../../redux/reducers';

export function getDiffPricing(periodsByService: IPeriodsByService, publication: IPublication): IDiffPricing {
  const periods = Object.values(periodsByService).reduce<IServicePeriod[]>((stash, service) => {
    return [...stash, ...Object.values(service.periods)];
  }, []);

  if (publication.period) {
    periods.push(publication.period);
  }

  let iterationId = null;
  let granuleGuid = null;

  periods.find(period => {
    const { diffPriceIterationId, diffPriceGranuleGuid } = period.tariffIdentificator;

    if (!!diffPriceIterationId || !!diffPriceGranuleGuid) {
      iterationId = diffPriceIterationId;
      granuleGuid = diffPriceGranuleGuid;

      return true;
    }

    return false;
  });

  return { iterationId, granuleGuid };
}
